module.exports = __webpack_public_path__ + "img/client (10).05abb600.jpg";